import React from 'react';
import styled from 'styled-components';
import MUIRadio, { RadioProps } from '@mui/material/Radio';
import { PALETTE, Z_INDEX } from '~/assets/styles/base';

// ベーシックなスタイルを定義
const StyledRadio = styled(MUIRadio)`
  &.MuiRadio-root {
    position: relative;
    &::before {
      content: '';
      background-color: ${PALETTE.white};
      border: 2px solid ${PALETTE.gray[400]};
      z-index: ${Z_INDEX.base};
      width: 21px;
      height: 21px;
      border-radius: 50%;
      transition: background-color, border-color;
      transition-duration: 0.3s;
      margin: 0 auto;
    }
    &.Mui-checked {
      &::before {
        background-color: ${PALETTE.white};
        border: 7px solid ${PALETTE.primary.main};
      }
    }
    svg.MuiSvgIcon-root {
      display: none;
    }
  }
`;

type Props = {
  value: string | number;
};

const Radio: React.FC<Props & RadioProps> = ({ value, ...props }): JSX.Element => (
  <StyledRadio data-testid="uiElements-Radio" value={value} {...props} />
);

export default Radio;
